// extracted by mini-css-extract-plugin
export default {"container":"style_container__xIH+i","content":"style_content__uYBd1","infomationArea":"style_infomationArea__A4yQG"};